import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import styles from 'components/transactionEditor/ActionButtons.module.css';
import i18n from 'i18n';
import BzmIcon from '../icons/BzmIcon';
import { FindReplaceItem } from 'components/transactionEditor/FindReplaceList';
import FindAndReplaceTagger from '../ui/servicePicker/FindAndReplaceTagger/FindAndReplaceTagger';

interface FindReplaceProps {
  id: string;
  findReplaceValues: FindReplaceItem;
  onChange: (name: string, value: string | string[], id: string) => void;
  onDelete: () => void;
  onAdd: () => void;
  displayAdd: boolean;
  isReadOnly?: boolean;
  index: number;
}

const FindReplaceRow = (props: FindReplaceProps) => {
  const handleChange = (e: any, id: string) => {
    const target = e.target as HTMLInputElement;
    props.onChange(target.name, target.value, id);
  };

  return (
    <Row id={props.id} className="mb-1">
      <Col md={3}>
        <Form.Group controlId={'qa-input-find-replace-find-' + props.id}>
          {props.index === 0 && <Form.Label>Find</Form.Label>}
          <Form.Control
            name="find"
            as="input"
            disabled={props.isReadOnly}
            onChange={(event: any) => handleChange(event, props.id)}
            placeholder={i18n.t('transactions:editor.find')}
            value={props.findReplaceValues.find ? props.findReplaceValues.find : ''}
          />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group controlId={'qa-input-find-replace-replace-' + props.id}>
          {props.index === 0 && <Form.Label>Replace</Form.Label>}
          <Form.Control
            name="replace"
            disabled={props.isReadOnly}
            as="input"
            onChange={(event: any) => handleChange(event, props.id)}
            placeholder={i18n.t('transactions:editor.replace')}
            value={props.findReplaceValues.replace ? props.findReplaceValues.replace : ''}
          />
        </Form.Group>
      </Col>
      <Col md={5}>
        <Form.Group controlId={'qa-input-find-replace-location-' + props.id}>
          {props.index === 0 && <Form.Label>Location</Form.Label>}
          <FindAndReplaceTagger
            onChange={(selection: string[]) => {
              props.onChange('location', selection, props.id);
            }}
            selected={props.findReplaceValues.location ? props.findReplaceValues.location : []}
          />
        </Form.Group>
      </Col>
      <Col md={1}>
        <div className={styles.actionButtons}>
          {props.index !== 0 && (
            <Button
              disabled={props.isReadOnly}
              id={'qa-btn-delete-find-replace' + props.id}
              onClick={props.onDelete}
              variant="danger"
              className="btn-circular"
              title={i18n.t('transactions:editor.deleteFindReplace')}
            >
              <BzmIcon variant={'icon-bzm-delete'} />
            </Button>
          )}
          {props.displayAdd && (
            <Button
              disabled={props.isReadOnly}
              id={'qa-btn-add-find-replace' + props.id}
              onClick={props.onAdd}
              variant="secondary"
              className="btn-circular ml-3"
              title={i18n.t('transactions:editor.addFindReplace')}
            >
              <BzmIcon variant={'icon-bzm-add'} className={'icon-theme-blue'} />
            </Button>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default FindReplaceRow;
